import * as React from "react"
import {
  CloudResourceType,
  NotificationUpsertInput,
} from "@modules/graphql/types"
import {
  NotificationIntegrationsDocument,
  useUpsertNotificationIntegrationMutation,
} from "@modules/notifications/deploys/queries.generated"
import { useShowSuccessToast } from "gatsby-interface"
import { notificationDeploys as notificationDeploysText } from "@modules/locales/default.js"

export const useUpsertNotificationIntegration = ({
  resourceId,
  resourceType,
}: {
  resourceId: string
  resourceType: CloudResourceType
}) => {
  const [
    mutate,
    { loading, error: mutationError },
  ] = useUpsertNotificationIntegrationMutation({
    refetchQueries: [
      {
        query: NotificationIntegrationsDocument,
        variables: { resourceId, resourceType },
      },
    ],
  })
  const [customError, setCustomError] = React.useState<Error | null>(null)

  const showSuccessToast = useShowSuccessToast()

  const upsertNotificationIntegration = (
    integration: NotificationUpsertInput
  ) =>
    mutate({ variables: { integration } })
      .then(() => {
        showSuccessToast(
          notificationDeploysText.messages.notificationSuccessfullyCreated
        )
      })
      .catch(setCustomError)

  return [
    upsertNotificationIntegration,
    { loading, error: customError || mutationError },
  ] as const
}
